module.exports = __webpack_public_path__ + "media/images/lp_v6_img03-b02549d669c9d83b837462a4e7df7a0e.webp";